export default "__VITE_ASSET__$U97AfxF__"